import Request from "./constants/Request.api"
import Response from "./constants/Response.api"
import Api from "./Api"

class General extends Api {
  constructor(user) {
    super()
    this.user = user
  }

  getProvinces = () => {
    const request = new Request({
      data: {
        url: "provinces",
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getDistricts = province_id => {
    const request = new Request({
      data: {
        url: "districts/" + province_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getSectors = district_id => {
    const request = new Request({
      data: {
        url: "sectors/" + district_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getCells = sector_id => {
    const request = new Request({
      data: {
        url: "cells/" + sector_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getVillages = cell_id => {
    const request = new Request({
      data: {
        url: "villages/" + cell_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getCompanyCategories = () => {
    const request = new Request({
      data: {
        url: "company-categories",
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  createCompany = details => {
    const request = new Request({
      data: {
        ...details,
        url: "companies",
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }

  getCompanies = () => {
    const request = new Request({
      data: {
        url: "companies/" + this.user.id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getApplicationDetails = id => {
    const request = new Request({
      data: {
        url: "application/" + id,
        client_id: this.user.id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getServiceAttachments = service_id => {
    const request = new Request({
      data: {
        url: "service/attachments/" + service_id,
        client_id: this.user.id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getServices =()=>{
     const request = new Request({
       data: {
         url: "services",
       },
     })

     return this.getRequest(request)

  }

  uploadFile = fileDetails => {
    const formData = new FormData()
    formData.append("file", fileDetails.file)
    formData.append("application_id", fileDetails.application_id)
    formData.append("description", fileDetails.description)

    const request = new Request({
      data: {
        formData: formData,
        url: "applications/upload/file",
        token: "Bearer " + this.user.token,
      },
    })
    return this.uploadRequest(request)
  }

  bulkFileUpload = files => {
    var uploadStatus = new Promise((resolve, reject) => {
      files.forEach(file => {
        this.uploadFile(file).then(response => {
          console.log("response from server upload")
          console.log(response)
        })
      })
    })

    uploadStatus.then(() => {
      return new Response({
        code: 200,
        message: "upload success",
        status: true,
      })
    })
  }

  getCertificate  = appId => {
    const request = new Request({
      data: {
        url: "verify/certificate/" + appId,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getQuantityMeasures = () => {
    const request = new Request({
      data: {
        url: "quantity-measures",
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  addRecycledQuantity = (data) => {
    const request = new Request({
      data: {
        url: "clients/report/recycled-quantity",
        ...data,
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }

  getRecycledStatus = (client_id) => {
    const request = new Request({
      data: {
        url: "application/check-plastic-bags-authorization/" + client_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }
}

export default General
